/**
 * @generated SignedSource<<f5cf6c850cb0d2793673954255c56596>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselItemTile_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly ecommerceTrackingParams: any | null;
  readonly firstPhotoWebPath: string | null;
  readonly heartPortfolioItems?: ReadonlyArray<{
    readonly portfolioId: string | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_item" | "ItemFolderWrapper_item" | "ItemHeartWrapper_item" | "useFavoritesItem_item">;
  readonly " $fragmentType": "CarouselItemTile_item";
};
export type CarouselItemTile_item$key = {
  readonly " $data"?: CarouselItemTile_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v1 = [
  {
    "kind": "Variable",
    "name": "loadPortfolioData",
    "variableName": "fetchFavorites"
  },
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselItemTile_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "thumb"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"thumb\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ecommerceTrackingParams",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    },
    {
      "condition": "fetchFavorites",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "heartPortfolioItems",
          "args": [
            {
              "kind": "Literal",
              "name": "portfolioType",
              "value": "HEART"
            },
            (v0/*: any*/)
          ],
          "concreteType": "PortfolioItemV2",
          "kind": "LinkedField",
          "name": "portfolioItems",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "portfolioId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_item"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "ItemFolderWrapper_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Literal",
          "name": "showSeller",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "0a4f666e9c612f7210f95ad8ef04cd7d";

export default node;
